import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/waist-to-height-calculator',
  component: () => import('../../routes/WaistToHeightCalculator.svelte'),
  card: {
    id: 'waist-to-height-calculator',
    title: 'Waist-to-Height Ratio',
    description: 'Calculate your WHtR to assess central obesity and health risk based on the ratio of your waist to your height.',
    icon: 'straighten',
    iconBgClass: 'bg-cyan-50',
    iconTextClass: 'text-cyan-600',
    href: '/waist-to-height-calculator',
    category: 'Health & Fitness',
  },
  seo: {
    title: 'Waist-to-Height Ratio Calculator – Free WHtR Health Risk Assessment',
    description: 'Free WHtR calculator to assess central obesity and health risk. Calculate your waist-to-height ratio and see how it compares to healthy thresholds. More accurate than BMI for many body types.',
  },
};

export default meta;